import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { authService } from "../dependencyInjection";
import { AuthError } from "../services/AuthService";
import { unsubscribe } from "../../../../utils";

export function useAuthError(): [AuthError | null, Dispatch<SetStateAction<AuthError | null>>] {
  const [errorCode, setErrorCode] = useState<AuthError | null>(null);
  useEffect(() => {
    const sub = authService.error$.subscribe((code) => {
      setErrorCode(code);
    });
    return unsubscribe(sub);
  }, []);
  return [errorCode, setErrorCode];
}
